// Тексты состояний сохранения и окон отказа, ухода и выхода (015: plan.md, «Ответы на чек-лист
// ux», CHK001, CHK005, CHK006, CHK007). Числа согласуются со словом и глаголом:
// «1 правка не дошла», «2 правки не дошли», «5 правок не дошли».
import { formatCount, formatNumber, plural } from '@kp/contracts';
import type { PluralForms } from '@kp/contracts';

export const EDIT_FORMS: PluralForms = ['правка', 'правки', 'правок'];
export const FIELD_FORMS: PluralForms = ['поле', 'поля', 'полей'];

/** Полоса под шапкой листа — тот же текст, что у полосы оболочки (ux.md, «Нет связи»). */
export const SHEET_OFFLINE_TEXT = 'Нет связи. Изменения сохранятся, когда связь вернётся';

/** Предупреждение один раз, когда очередь только в памяти (ux CHK007). */
export const STORAGE_WARNING =
  'Правки не переживут перезагрузку страницы: хранилище браузера недоступно';

export const DISCARD_ALL_LABEL = 'Отменить несохранённые правки';

/** Одно число (1, 21, 101) — глагол и местоимение в единственном числе. */
function isOne(n: number): boolean {
  return plural(n, ['one', 'few', 'many']) === 'one';
}

/** «Не сохранено правок: 3» — число после двоеточия, слово не согласуется. */
export function unsavedCountText(n: number): string {
  return `Не сохранено правок: ${formatNumber(n)}`;
}

/** «Конфликт: 2 поля». */
export function conflictText(fields: number): string {
  return `Конфликт: ${formatCount(fields, FIELD_FORMS)}`;
}

/** «Ещё 21 поле». */
export function moreFieldsText(n: number): string {
  return `Ещё ${formatCount(n, FIELD_FORMS)}`;
}

/** Окно отказа: «2 правки не дошли до сервера. Таблица покажет версию сервера, эти правки пропадут». */
export function discardText(n: number): string {
  const one = isOne(n);
  return `${formatCount(n, EDIT_FORMS)} ${one ? 'не дошла' : 'не дошли'} до сервера. Таблица покажет версию сервера, ${
    one ? 'эта правка пропадёт' : 'эти правки пропадут'
  }`;
}

/** Окно ухода из протокола: правки остаются в браузере. */
export function leaveText(n: number): string {
  const one = isOne(n);
  return `${unsavedCountText(n)}. ${one ? 'Она останется' : 'Они останутся'} в этом браузере и ${
    one ? 'отправится' : 'отправятся'
  }, когда вы снова откроете протокол`;
}

/** Окно выхода из системы: очередь пользователя очищается. */
export function logoutText(n: number): string {
  return `${unsavedCountText(n)}. После выхода ${isOne(n) ? 'она пропадёт' : 'они пропадут'}`;
}

/**
 * Причина после «Ошибка:» — со строчной буквы: «Ошибка: нет доступа к этому действию».
 * Сокращение в начале («MIN-005», «ФИО») не трогается.
 */
export function reasonAfterColon(reason: string): string {
  const [first = '', second = ''] = reason;
  if (first === '' || second.toUpperCase() === second) return reason;
  return first.toLowerCase() + reason.slice(1);
}
